<template>
  <div
    class="status"
    :style="{
      background: props.bgColor,
      color: props.labelColor,
      border: props.isBordered ? `0.063rem solid ${props.labelColor}` : '',
    }"
  >
    <div class="status__dot" v-if="props.isDotted"></div>

    {{ props.label }}
    <div class="status__close-area" v-if="isClosable">
      <div class="status__divider"></div>
      <div class="status__inner-icon" @click="close"><CrossCompactIcon></CrossCompactIcon></div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { defineProps, PropType, defineEmits } from "vue";
import { TirPmStatusBgEnum, TirPmStatusTextEnum } from "./enums";
import { CrossCompactIcon } from "tir-style-system/icons/outline";

const emit = defineEmits<{
  (eventName: "onClose"): void;
}>();

const close = () => {
  emit("onClose");
};

const props = defineProps({
  /**
   * С обводкой
   */
  isBordered: { type: Boolean as PropType<boolean>, default: false },
  /**
   * Лейбл
   */
  label: { type: String as PropType<String>, default: "" },
  /**
   * Цвет лейбла
   */
  labelColor: {
    type: String as PropType<TirPmStatusTextEnum>,
    default: TirPmStatusTextEnum.Default,
  },
  /**
   * Включает точку слева
   */
  isDotted: { type: Boolean as PropType<boolean>, default: false },
  /**
   * Включает точку слева
   */
  isClosable: { type: Boolean as PropType<boolean>, default: false },
  /**
   * Цвет фона
   */
  bgColor: { type: String as PropType<TirPmStatusBgEnum>, default: TirPmStatusBgEnum.Positive },
});
</script>

<style lang="scss">
@import "./style.scss";
</style>
